// Main javascript entry point
// Should handle bootstrapping/starting application
'use strict';

import Search from "../modules/header/search";
import RichTextBlock from "../modules/standard/rich-text-block";
import HeaderHero from "../modules/landing/header-hero";
import MultiColumnLayout from "../modules/landing/multi-column-layout";
import Project from "../modules/project";
import SideNavigation from "../modules/side-navigation";
import MobileMenu from "../modules/mobile-menu";
import RelatedStories from "../modules/related-stories";
import Downloads from "../modules/downloads";
import PhotoGallery from "../modules/landing/photo-gallery";
import UpcomingEvents from "../modules/landing/upcoming-events";
import LatestNews from "../modules/landing/latest-news";
import TwoColumnLayout from "../modules/landing/two-column-layout";

window.$ = jQuery;

$(function () {
  new Search();
  new TwoColumnLayout();
  new LatestNews();
  new UpcomingEvents();
  new PhotoGallery();
  new Downloads();
  new RelatedStories();
  new MobileMenu();
  new SideNavigation();
  new Project();
  new MultiColumnLayout();
  new HeaderHero();
  new RichTextBlock();
});
